/** Loops through itemsState.activeObjs to organize ttCartData
 * ttCartData then gets fed into cards
 */

export const getShoppingCartData = (componentsState, itemsState, componentsIndexObj) => {
  // drill into component sections to get pricing
  const [deskModelSection] = componentsState.array[componentsIndexObj.deskModelIndex].sections.filter(
    (item) => item._id === itemsState.activeObjs.desk_model.section
  );

  let ttCartData = []; // detailed data of each product added to cart. Used for google analytics
  let shopifyIds = []; // shopify product data used to submit to the cart on client's website
  let shopifyBuilderSummary = {}; // contains comprehensive written summary of product that's shown in the cart on clients website

  const iterate = (itemsStateActiveObjs) => {
    Object.keys(itemsStateActiveObjs).forEach((key) => {
      let cartItemObj = {};

      // drill into nested objects in itemsState
      if (typeof itemsStateActiveObjs[key] === "object" && itemsStateActiveObjs[key] !== null) {
        iterate(itemsStateActiveObjs[key]);
      }

      /**
       *
       * id, name, price, and quantity are data layer variables for google analytcs.
       * DONT REMOVE OR CHANGE THEM
       *
       */

      if (key === "desk_model") {
        cartItemObj.id = itemsStateActiveObjs[key]._id;
        cartItemObj.title = "Desk Model";
        cartItemObj.name = deskModelSection.displayName;
        cartItemObj.itemDescription = itemsStateActiveObjs[key].displayName;
        cartItemObj.previewImg = itemsStateActiveObjs[key]?.thumbnail ?? null;
        cartItemObj.price = itemsStateActiveObjs[key]?.price;
        cartItemObj.section = itemsStateActiveObjs[key].section;
        cartItemObj.className = "deskModel";
        cartItemObj.quantity = 1;
        cartItemObj.category = "DeskModel";
        ttCartData.push(cartItemObj);

        shopifyIds.push(itemsStateActiveObjs[key].shopify);

        shopifyBuilderSummary["Desk Model"] = deskModelSection.displayName;
        shopifyBuilderSummary["Work Surface Size"] = cartItemObj.itemDescription;
      } else if (key === "desk_material") {
        cartItemObj.id = itemsStateActiveObjs[key]._id;
        cartItemObj.title = "Desk Surface Color";
        cartItemObj.name = itemsStateActiveObjs[key].displayName;
        cartItemObj.itemDescription = null;
        cartItemObj.previewImg = itemsStateActiveObjs[key].thumbnail;
        cartItemObj.price = itemsStateActiveObjs[key]?.price ?? null;
        cartItemObj.section = itemsStateActiveObjs[key].section;
        cartItemObj.className = "deskMaterial";
        cartItemObj.quantity = 1;
        cartItemObj.category = "Surface Material";
        cartItemObj.shopify = itemsStateActiveObjs[key].shopify;
        cartItemObj.isIncluded = itemsStateActiveObjs[key].metaData?.isIncluded;
        ttCartData.push(cartItemObj);

        shopifyIds.push(itemsStateActiveObjs[key].shopify);

        shopifyBuilderSummary["Surface Finish"] = itemsStateActiveObjs[key].displayName;
      }
      // else if (key === "base_material") {
      //   cartItemObj.id = itemsStateActiveObjs[key]._id;
      //   cartItemObj.title = "Base Color";
      //   cartItemObj.name = itemsStateActiveObjs[key].displayName;
      //   cartItemObj.itemDescription = null;
      //   cartItemObj.previewImg = itemsStateActiveObjs[key].thumbnail;
      //   cartItemObj.price = itemsStateActiveObjs[key].price;
      //   cartItemObj.section = itemsStateActiveObjs[key].section;
      //   cartItemObj.className = "baseMaterial";
      //   cartItemObj.quantity = 1;
      //   cartItemObj.category = "Base Material";
      //   cartItemObj.shopify = itemsStateActiveObjs[key].shopify;
      //   cartItemObj.isIncluded = itemsStateActiveObjs[key].metaData?.isIncluded;
      //   ttCartData.push(cartItemObj);

      //   // some shopify values are arrays, some are single objects, so handle that here
      //   if (Array.isArray(itemsStateActiveObjs[key].shopify)) shopifyIds.push(...itemsStateActiveObjs[key].shopify);
      //   else if (itemsState.activeObjs["desk_model"]._id.includes("dome") || itemsState.activeObjs["desk_model"]._id.includes("battle_station"))
      //     shopifyIds.push(itemsStateActiveObjs[key].shopify.included);
      //   else if (itemsState.activeObjs["desk_model"]._id.includes("cubicle_rectangle_straight"))
      //     shopifyIds.push(itemsStateActiveObjs[key].shopify.straightFrontEdge);
      //   else shopifyIds.push(itemsStateActiveObjs[key].shopify.default);

      //   shopifyBuilderSummary["Base Color"] = itemsStateActiveObjs[key].displayName;
      // }

      // accessories are optional, so make sure they exist
      else if (key === "accessories" && itemsStateActiveObjs[key].array.length > 0) {
        // loop through acccessories array
        itemsStateActiveObjs[key].array.forEach((accessory, index) => {
          cartItemObj = {};
          cartItemObj.id = accessory._id;
          cartItemObj.title = "Accessory";
          cartItemObj.name = accessory.displayName || accessory.multiLineDisplayName?.join("\n");
          cartItemObj.itemDescription =
            accessory._id === "storage_drawers" ? `Surface Color: ${itemsState.activeObjs.materials.desk_material.displayName}` : null;
          cartItemObj.previewImg = accessory.thumbnail;
          cartItemObj.price = accessory.price;
          cartItemObj.section = accessory.section;
          cartItemObj.className = "accessories";
          cartItemObj.quantity = 1;
          cartItemObj.category = "Accessory";
          cartItemObj.shopify = accessory.shopify;
          cartItemObj.isIncluded = accessory.metaData?.isIncluded;

          if (accessory._id === "no_axys_level") return;

          if (accessory.shopify) {
            if (Array.isArray(accessory.shopify)) {
              shopifyIds.push(...accessory.shopify);
            } else shopifyIds.push(accessory.shopify);
            // else if (accessory.metaData?.isIncluded) {
            // if (accessory.shopify.included) {
            //   shopifyIds.push(accessory.shopify.included);
            // } else {
            //   shopifyIds.push(accessory.shopify);
            // }
            // }
          }

          ttCartData.push(cartItemObj);
          shopifyBuilderSummary[`Accessory ${index + 1}`] = accessory.displayName;
        });
      }
    });
  };

  iterate(itemsState.activeObjs);

  // Reorder the ttCartData array to control card display order
  const reorderCartItems = (cartItems) => {
    // Create a new array with the desired order based on className or other properties
    const orderedItems = [];

    // Example ordering: desk_model first, then base_material, then desk_material, then accessories
    const findItemsByClass = (className) => cartItems.filter((item) => item.className === className);

    // Add items in your preferred order
    orderedItems.push(...findItemsByClass("deskModel"));
    orderedItems.push(...findItemsByClass("deskMaterial"));
    // orderedItems.push(...findItemsByClass("baseMaterial"));
    const accessories = findItemsByClass("accessories");

    // Define priority patterns for accessories - items will be matched in this order
    // You only need to define the items you want at the top - others will be sorted afterward
    const accessoryPriorityPatterns = [
      // Partial matches (will be checked for any item containing these strings)
      { type: "partial", pattern: "axys_level" }, // All axys level packages
      { type: "partial", pattern: "monitor" }, // All other monitor-related items
      { type: "partial", pattern: "rollervision" },
    ];

    // Helper function to find the priority index and matched pattern of an accessory
    const getPriorityMatch = (accessory) => {
      // Check through each pattern in order
      for (let i = 0; i < accessoryPriorityPatterns.length; i++) {
        const { type, pattern } = accessoryPriorityPatterns[i];

        // For exact matches
        if (type === "exact" && accessory.id === pattern) {
          return { index: i, pattern };
        }
        // For partial matches - make sure we get specific matches first
        else if (type === "partial" && accessory.id?.includes(pattern)) {
          // If the accessory ID exactly equals the pattern, give it slightly higher priority
          // This helps ensure more specific patterns like "monitor" sort correctly
          // compared to broader patterns that might match partially
          const exactMatchBonus = accessory.id === pattern ? 0.1 : 0;
          return { index: i - exactMatchBonus, pattern };
        }
      }
      return { index: Infinity, pattern: null }; // No match, put at the end
    };

    // Sort accessories based on priority patterns
    const sortedAccessories = [...accessories].sort((a, b) => {
      const matchA = getPriorityMatch(a);
      const matchB = getPriorityMatch(b);

      // If both items have a priority, sort by their priority
      if (matchA.index !== Infinity && matchB.index !== Infinity) {
        return matchA.index - matchB.index;
      }

      // If only one item has a priority, prioritize it
      if (matchA.index !== Infinity) return -1;
      if (matchB.index !== Infinity) return 1;

      // For items without a priority, sort alphabetically by name
      return a.name?.localeCompare(b.name) || 0;
    });

    // Add sorted accessories to the final ordered items array
    orderedItems.push(...sortedAccessories);

    return orderedItems;
  };

  const orderedCartData = reorderCartItems(ttCartData);

  console.log("orderedCartData", orderedCartData);

  return [orderedCartData, shopifyIds.reverse(), shopifyBuilderSummary];
};

// Helper function to reorder arrays - can be used outside this module if needed
export const reorderArray = function (array, from, to) {
  if (from < 0 || to < 0 || from >= array.length || to >= array.length) return array;
  const newArray = [...array];
  newArray.splice(to, 0, newArray.splice(from, 1)[0]);
  return newArray;
};
